import sortedCountries from "./_sorted-countries";

const Locale = TheApp.ContentLocale;
const localeShort = TheApp.Env.LocaleShort;
const Res = TheApp.Res[Locale];

export function strRemoveSpaces(str = null) {
    if (!str) return "";

    if (`${str}`.length === 1) {
        if (str === " ")
            return ""
        return `${str}`.toLowerCase();
    }

    return `${str}`.trim().split(" ").join("");
}

export function formatDate(date, format = "yyyy-MM-dd", sep = "/") {
    const d = new Date(date);

    if (isNaN(d.getTime())) return "";

    const year = `${d.getFullYear()}`;
    const month =
        d.getMonth() + 1 >= 10 ? `${d.getMonth() + 1}` : `0${d.getMonth() + 1}`;
    const day = d.getDate() >= 10 ? `${d.getDate()}` : `0${d.getDate()}`;

    if (format === "yyyy-MM-dd") return [year, month, day].join(sep);
    else if (format === "dd-MM-yyyy") return [day, month, year].join(sep);
    else if (format === "MM-dd-yyyy") return [month, day, year].join(sep);
}

export function extractPaymentData(data = {}, GWUID) {
    const Amount = parseInt(data.AmountFree);

    const _data = {
        Locale: TheApp.Env.LocaleShort,
        Recurrence: data.Recurrence,
        Amount: isNaN(Amount) ? null : Amount,
        Currency: "EUR",
        Name: data.Name,
        Surname: data.Surname,
        Email: data.Email,
        Birthday: formatDate(data.Birthday, 'dd-MM-yyyy'),
        Address: data.Address,
        ZipCode: data.ZipCode,
        City: data.City,
        Country: data.Country,
        FiscalNumber: data.FiscalNumber?.toUpperCase(),
        Project: data.Project,
        Privacy: data.Privacy?.length === 1 ? data.Privacy[0] : "0",
        GWUID,
    };

    return _data;
}

export function validateBirthday(input) {
    const value = input.value;
    let _value = new Date(value);

    if (isNaN(_value.getTime()))
        _value = null;

    if (!input.required && !value)
        return { flag: null, msg: "" };

    if (input.required && !value)
        return { flag: false, msg: translation("ERROR.FieldMandatory") };

    if (!input.min && !input.max)
        return { flag: true, msg: "" };

    if (input.min && _value > input.min)
        return {
            flag: false,
            msg: translation("ERROR.Over18", [formatDate(input.min, "dd-MM-yyyy")]),
        };

    if (input.max && _value < input.max)
        return {
            flag: false,
            msg: translation("ERROR.Max", [formatDate(input.max, "dd-MM-yyyy")]),
        };

    return { flag: true, msg: "" };
}

export function validateFiscalNumber(input) {
    const _value = strRemoveSpaces(input?.value?.toUpperCase());
    let validi, i, s, set1, set2, setpari, setdisp;

    if (!input.required && _value === "")
        return { flag: null, msg: "" };

    if (input.required && _value === "")
        return { flag: false, msg: translation("ERROR.FieldMandatory") };

    if (_value.length !== 16)
        return { flag: false, msg: translation("ERROR.CharLength", ["16"]) };

    validi = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

    for (i = 0; i < 16; i++) {
        if (validi.indexOf(_value.charAt(i)) == -1)
            return { flag: false, msg: translation("ERROR.InvalidFiscalCode") };
    }

    set1 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    set2 = 'ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ';
    setpari = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    setdisp = 'BAKPLCQDREVOSFTGUHMINJWZYX';
    s = 0;

    for (i = 1; i <= 13; i += 2)
        s += setpari.indexOf(set2.charAt(set1.indexOf(_value.charAt(i))));

    for (i = 0; i <= 14; i += 2)
        s += setdisp.indexOf(set2.charAt(set1.indexOf(_value.charAt(i))));

    if (s % 26 != _value.charCodeAt(15) - 'A'.charCodeAt(0))
        return { flag: false, msg: translation("ERROR.InvalidFiscalCode") };

    return { flag: true, msg: "" };
}

export function getQueryStringData() {
    const data = {};

    if (!location.href.includes("?"))
        return data;

    if (location.href.includes("&")) {
        location.href
            .slice(location.href.indexOf("?") + 1, location.href.length)
            .split("&")
            .forEach((q) => {
                const [key, value] = q.split("=");
                if (!(key.length > 0 && value.length > 0))
                    return;
                data[key] = value.split("+");
            });

    } else {
        const [key, value] =
            location.href
                .slice(location.href.indexOf("?") + 1, location.href.length)
                .split("=");

        if (!(key.length > 0 && value.length > 0))
            return data;

        data[key] = value.split("+");
    }

    delete data[location.href];

    return data;
}

export function translation(key, values = []) {
    let str = Res[key];

    if (!str) return "";

    values.forEach((value, i) => str = str.replace(`{${i}}`, value));

    return str;
}

export function labelPatcher(container, data, key, value) {
    let _value = value;

    if (key === "Recurrence") {
        _value =
            container?.querySelector(`[data-name="${key}"] [data-value="${value}"] .input-label`)?.textContent;

    } else if (key === "Amount") {
        if (data?.AmountFree)
            _value = data?.AmountFree;

    } else if (key === "Project") {
        if (!data?.Project) {
            _value = translation("lblLetSFDecide");

        } else {
            _value = TheApp.Projects?.find(p => p.Uid === value)?.Title;
        }

    } else if (key === "Birthday") {
        if (_value)
            formatDate(value, "dd-MM-yyyy");

    } else if (key === "Country") {
        _value = sortedCountries.find(c => c.alpha2 === _value)?.[localeShort];
    }

    return _value;
}

export function elapsedStart(callback) {
    let start;
    const animate = (timestamp) => {
        if (start === undefined)
            start = timestamp;
        const elapsed = timestamp - start;

        if (elapsed < 1) {
            requestAnimationFrame((t) => animate(t));

        } else {
            callback?.();
        }
    }

    requestAnimationFrame(animate);
}